export const EXPERIENCE_LIST_REQUEST = 'EXPERIENCE_LIST_REQUEST';
export const EXPERIENCE_LIST_SUCCESS = 'EXPERIENCE_LIST_SUCCESS';
export const EXPERIENCE_LIST_FAIL = 'EXPERIENCE_LIST_FAIL';

export const EXPERIENCE_DETAILS_REQUEST = 'EXPERIENCE_DETAILS_REQUEST';
export const EXPERIENCE_DETAILS_SUCCESS = 'EXPERIENCE_DETAILS_SUCCESS';
export const EXPERIENCE_DETAILS_FAIL = 'EXPERIENCE_DETAILS_FAIL'; 